import { THEME_SPACING } from '@/styles/constants';
import { type ThemeOptions } from '@mui/material/styles';

export const spacing: ThemeOptions['spacing'] = THEME_SPACING;
